const qywxUtil = {}
const jsApiList =  ['scanQRCode','chooseImage','getLocalFileData','getLocalImgData'];

import { getSignNature } from '../../api/authorize'
import Vue from 'vue'

qywxUtil.isReady = false;
qywxUtil.init = async ()=>{
    return new Promise(async (res,rej)=>{
        if(qywxUtil.isReady){
            return;
        }

        let timestamp = Number.parseInt(Date.now()/1000);
        let nonceStr = '123';
        let resp  = null;
        try
        {
          resp = await getSignNature(nonceStr,timestamp, window.location.href.split('#')[0]);
        }
        catch(e){
            rej(e);
        }
        
        if(!resp || resp.code != 200 || !resp.data){
            rej('获取SignNature失败');
        }
        
        let signature = resp.data;

        wx.config({
            beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: Vue.prototype.$isDebug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: Vue.prototype.$appId, // 必填，企业微信的corpID
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: jsApiList // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        });

        wx.ready(function(data){
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            qywxUtil.isReady = true;    
            res('ok');    
        });
        
        wx.error(function(err){
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            qywxUtil.isReady = false;
            rej(err);
        });
    });
}

qywxUtil.scanQRCode = async ()=>{
    return new Promise(async (res,rej)=>{
        wx.scanQRCode({
            desc: 'scanQRCode desc',
            needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
         //   scanType: ["qrCode"], // 可以指定扫二维码还是条形码（一维码），默认二者都有
            success: function(data) {
                res(data);
            },
            error: function(err) {
                alert(JSON.stringify(err))
                if (err.errMsg.indexOf('function_not_exist') > 0) {
                    alert('版本过低请升级')
                }
                rej(err);
            }
        });     
    });
}

qywxUtil.photo = async ()=>{
    return new Promise(async (res,rej)=>{
        wx.chooseImage({
            count: 9, // 默认9
            sizeType: [ 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
            defaultCameraMode: "normal", //表示进入拍照界面的默认模式，目前有normal与batch两种选择，normal表示普通单拍模式，batch表示连拍模式，不传该参数则为normal模式。从3.0.26版本开始支持front和batch_front两种值，其中front表示默认为前置摄像头单拍模式，batch_front表示默认为前置摄像头连拍模式。（注：用户进入拍照界面仍然可自由切换两种模式）
            isSaveToAlbum: 1, //整型值，0表示拍照时不保存到系统相册，1表示自动保存，默认值是1
            success: async function (o) {
                var result = [];
                var localIds = o.localIds; // 返回选定照片的本地ID列表，
                // andriod中localId可以作为img标签的src属性显示图片；
                // iOS应当使用 getLocalImgData 获取图片base64数据，从而用于img标签的显示（在img标签内使用 wx.chooseImage 的 localid 显示可能会不成功）

                for(var index in localIds){
                  
                    var localId = localIds[index];
                    var data =  await getLocalFiles(localId);

                    result.push({
                        fileName:localIds[index],
                        data:data
                    });
                }

                res(result);
            }
        });
    });
}

async function getLocalFiles(localId) {
    
    return new Promise(async (res,rej)=>{
        wx.getLocalImgData({
            localId: localId, // 图片的localID
            success: function (o) {
                var localData = o.localData; // localData是图片的base64数据，可以用img标签显示

                res(localData);
            }
        });
    });
}

export default qywxUtil